import apiFetch from '../../../utils/apiFetch';
export async function multiattackRequest(campaignId, context, command, input = {}) {
 const root=`/campaigns/${encodeURIComponent(campaignId)}/multiattacks`;
 const url=command==='current' ? `${root}/current` : command==='start' ? `${root}/start`
  : `${root}/${encodeURIComponent(context.sequenceId)}${context.stepId ? `/steps/${encodeURIComponent(context.stepId)}` : ''}/${command}`;
 const response=await apiFetch(url,command==='current' ? {cache:'no-store'} : {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(input)});
 const record=await response.json();if(!response.ok)throw Object.assign(new Error(record.message || 'Multiattack could not continue.'),{status:response.status});return record;
}
export async function captureMultiattackRoll(campaignId,context,eventId,key,clientId,roll){
 const recoveryKey=`multiattack-capture:${campaignId}:${context.sequenceId}:${context.stepId}:${eventId}:${key}`;
 let saved;try{saved=JSON.parse(sessionStorage.getItem(recoveryKey));}catch{}
 if(saved){const record=await multiattackRequest(campaignId,context,'roll-capture',saved);sessionStorage.removeItem(recoveryKey);return record.value;}
 const begun=await multiattackRequest(campaignId,context,'roll-begin',{eventId,key,clientId});
 if(begun.value!==undefined)return begun.value;
 const value=await roll();if(value==null)throw new Error('The roll was interrupted. Verify it manually or end Multiattack.');
 const evidence={eventId,key,clientId,lease:begun.lease,value};
 try{sessionStorage.setItem(recoveryKey,JSON.stringify(evidence));}catch{}
 const captured=await multiattackRequest(campaignId,context,'roll-capture',evidence);
 try{sessionStorage.removeItem(recoveryKey);}catch{}
 return captured.value;
}
